import {
  signup,
  usePasswordValidation,
  useScreen,
  useSignupPassword,
} from '@auth0/auth0-acul-react/signup-password';

import { executeSafely } from '@/utils/helpers/executeSafely';

export const useSignupPasswordManager = (password: string = '') => {
  useSignupPassword();
  const screen = useScreen();

  const { texts, data, editLink, captcha, isCaptchaAvailable } = screen ?? {};

  // Pre-filled identifier from signup-id screen
  const email = data?.email;
  const username = data?.username;
  const phoneNumber = data?.phoneNumber;

  // Password validation using Auth0 SDK
  const passwordValidation = usePasswordValidation(password, {
    includeInErrors: true,
  });

  const handleSignup = async (
    signupPassword: string,
    captchaValue: string | undefined,
  ): Promise<void> => {
    const options: {
      password: string;
      email?: string;
      username?: string;
      phoneNumber?: string;
      captcha?: string;
    } = {
      password: signupPassword?.trim() || '',
      ...(email && { email }),
      ...(username && { username }),
      ...(phoneNumber && { phoneNumber }),
    };

    if (isCaptchaAvailable && captchaValue?.trim()) {
      options.captcha = captchaValue.trim();
    }

    await executeSafely(`Signup with password`, () => signup(options));
  };

  const handleEditIdentifier = (): void => {
    if (editLink) {
      window.location.assign(editLink);
    }
  };

  return {
    texts: texts ?? {},
    email,
    username,
    canEditIdentifier: !!editLink,
    passwordValidation,
    handleSignup,
    handleEditIdentifier,
    captcha,
    isCaptchaAvailable,
  };
};
